import classNames from 'classnames';
import React from 'react';

import {useI18n} from '@udemy/i18n';

import styles from './personal-plan-hero-stats.module.less';

interface PersonalPlanHeroStatItem {
    /** The figure the stat leads with, e.g. `600+`. */
    count: string;
    /** What the figure counts, e.g. `Skill Assessments`. */
    label: string;
    /** Hidden in the stacked layout, so it must not carry anything the label does not. */
    description: string;
}

export interface PersonalPlanHeroStatsProps {
    className?: string;
}

export const PersonalPlanHeroStats = ({className}: PersonalPlanHeroStatsProps) => {
    const {gettext} = useI18n();
    const items = getDefaultPersonalPlanHeroStats(gettext);

    return (
        <dl className={classNames(className, styles['plan-stats'])}>
            {items.map((item) => (
                <div className={styles['stat-wrapper']} key={item.label}>
                    <dt className={styles['title']}>
                        {/* The space only shows once the two sit on a single line. */}
                        <span className={styles['count']}>{item.count}</span>{' '}
                        <span className={styles['label']}>{item.label}</span>
                    </dt>
                    <dd className={styles['description']}>{item.description}</dd>
                </div>
            ))}
        </dl>
    );
};

function getDefaultPersonalPlanHeroStats(
    gettext: (value: string) => string,
): PersonalPlanHeroStatItem[] {
    return [
        {
            count: gettext('600+'),
            label: gettext('Skill Assessments'),
            description: gettext(
                'Identify your skill gaps and discover where you can improve the most.',
            ),
        },
        {
            count: gettext('1,800+'),
            label: gettext('Role Play Scenarios'),
            description: gettext(
                'Perfect what you learn with instant feedback and unlimited retries.',
            ),
        },
        {
            count: gettext('180+'),
            label: gettext('In-Course Lab Workspaces'),
            description: gettext('Get hands-on with applied learning and technical skills.'),
        },
        {
            count: gettext('12,000+'),
            label: gettext('Certification Prep Courses'),
            description: gettext(
                'Show employers like AWS, Microsoft, and CompTIA that you know the work.',
            ),
        },
    ];
}
